import React, { useState, useRef } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import axios from "axios";
import AutocompleteArrow from "../AutocompleteDropdownArrow";
import "./index.css";

const ApiAutocompleteDropdown = ({
  chosen,
  setValue,
  disabled = false,
  styleNo = 1,
  edit,
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const divRef = useRef();

  const fetchSearchResults = async (query) => {
    try {
      const response = await axios.get(
        "https://lca.aau.dk/api/activity-names/",
        {
          headers: {
            Authorization: "Token 7a5a1d9f0926a74b538448307ad2c2be8a925cda",
            "Content-Type": "application/json",
          },
          params: { search: query },
        }
      );

      const results = response.data.results.map((item) => ({
        ...item,
        value: item.name,
      }));

      setSearchResults(results);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleInputChange = (event, value) => {
    setInputValue(value);
    if (value) {
      fetchSearchResults(value);
    } else {
      setSearchResults([]);
    }
  };

  if (!edit) {
    return <h4>{chosen?.value || chosen || ""}</h4>;
  }

  return (
    <div className="w-100" ref={divRef}>
      <Autocomplete
        className={`azilis__dropdown__style${styleNo}`}
        onChange={(event, opt) => setValue(opt)}
        value={chosen}
        disabled={disabled}
        options={searchResults}
        onInputChange={handleInputChange}
        inputValue={inputValue}
        getOptionLabel={(option) => option.value || ""}
        popupIcon={<AutocompleteArrow />}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              sx: { fontSize: "12px" },
            }}
            InputLabelProps={{ sx: { fontSize: "12px" } }}
          />
        )}
        renderOption={(props, option) => <li {...props}>{option.value}</li>}
        componentsProps={{
          paper: { sx: { width: 300 } },
          clearIndicator: {
            sx: {
              color: "white",
              right: "-5px",
              top: "10%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              "& .MuiSvgIcon-root": { fontSize: "12px" },
            },
          },
        }}
        sx={{
          "& .MuiAutocomplete-inputRoot": { paddingRight: "0" },
          "&.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root": {
            paddingRight: "0",
          },
          "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root":
            { paddingRight: "5px" },
          "& .MuiAutocomplete-popupIndicator": { top: "5px" },
        }}
      />
    </div>
  );
};

export default ApiAutocompleteDropdown;
